<template>
  <span class="ddt-spinner" role="status" aria-label="Carregando" />
</template>
